import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';

import * as fromRoot from '../../store';
import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NewsItemGuard  {
  constructor(private store: Store<fromStore.ContentState>) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getNewsEntities).pipe(
      withLatestFrom(this.store.select(fromRoot.getRouterState)),
      tap(([news, routerState]) => {
        if (!news[routerState.state.params.newsId]) {
          this.store.dispatch(fromStore.LoadNewsItem({ id: routerState.state.params.newsId }));
        }
      }),
      map(([news, routerState]) => {
        return news[routerState.state.params.newsId] !== null;
      }),
      filter((loaded: boolean) => loaded),
      take(1)
    );
  }
}
